import api from '../axiosConfig'
export default{
    mutations: {
        Result: () => {
            return false
        }
    },
    actions:{
        DeleteResponse({commit}, urlID){
            return new Promise ((resolve, reject) => {
                let config = {
                    headers: {
                        'x-api-key': localStorage.getItem('userToken')
                    }
                }
                commit('Result')
                api.delete(urlID, config).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
}